import axios from 'axios';
import { evaluationApiUrl } from './Config';
import { getAppSessionToken } from './Auth';

export const submitEvaluationResult = async (payload) => {
    if (!evaluationApiUrl || !payload) {
        return { ok: false, skipped: true };
    }

    const appSessionToken = getAppSessionToken();

    try {
        const response = await axios.post(evaluationApiUrl, payload, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                ...(appSessionToken ? { 'X-App-Session-Token': appSessionToken } : {}),
            },
            validateStatus: (status) => status < 500,
        });

        return response.data || { ok: response.status < 400 };
    } catch (error) {
        console.warn('Failed to store evaluation result.', error);

        return { ok: false };
    }
};
